import React from 'react';
import { useField, useFormikContext } from 'formik';
import clsx from 'clsx';

/**
 * Website/URL input with visual https:// prefix.
 * Strips protocol for display, stores full URL with https://.
 */
const WebsiteInput = ({
  name,
  placeholder = 'example.com',
  className,
  disabled,
  autoFocus,
  onBlur: onBlurProp,
}) => {
  const { setFieldValue, setFieldTouched } = useFormikContext();
  const [field] = useField(name);

  // Strip https:// for display
  const displayValue = (field.value || '').replace(/^https?:\/\//, '');

  const handleChange = e => {
    const raw = e.target.value.replace(/^https?:\/\//, '');
    setFieldValue(name, raw ? `https://${raw}` : '');
  };

  const handleBlur = e => {
    const raw = (e.target.value || '').replace(/^https?:\/\//, '').trim();
    const fullUrl = raw ? `https://${raw}` : '';
    setFieldValue(name, fullUrl);
    setFieldTouched(name, true);
    onBlurProp?.(e, fullUrl);
  };

  return (
    <div className="flex w-full">
      <div className="bg-gray-50 dark:bg-card flex items-center rounded-l-md border border-gray-200 dark:border-border border-r-0 py-1.5 px-3 text-gray-500 dark:text-muted-foreground">
        https://
      </div>
      <input
        type="text"
        id={name}
        name={name}
        value={displayValue}
        placeholder={placeholder}
        autoFocus={autoFocus}
        disabled={disabled}
        onChange={handleChange}
        onBlur={handleBlur}
        className={clsx(
          'appearance-none block w-full py-1.5 px-2 text-gray-800 dark:text-foreground rounded-l-none rounded-r-md border-none shadow-input focus:shadow-input-focus',
          { 'opacity-50': disabled },
          className,
        )}
      />
    </div>
  );
};

export default WebsiteInput;
